export default __webpack_public_path__ + "static/media/sc4.9009cf62.png";